const statusNames = {
  SUBSCRIPTIONS: 'subscriptions',
  CURRENT_PACKAGE: 'current_package',
  REACTIVATE_SUBSCRIPTION: 'reactivate-subscription',
  CANCEL_SUBSCRIPTION: 'cancel-subscription',
  RESCHEDULE_SUBSCRIPTION: 'reschedule-subscription',
};

export default statusNames;
